import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useResponsive } from "../../hooks/useResponsive";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { TrackNowButton } from "../../ui/TrackNowButton";
import ClientTableFilter from "../../customer/ClientTableFilter";
import { TextField, InputAdornment } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DataTableBase from "../../common/DataTableBase";
import PostAwardToolbox from "./PostAwardToolbox";
import Typography from "@mui/material/Typography";
// import SlidingDrawer from "../common/SlidingDrawer";

import { tokens } from "../../../theme/tokens";
import _, { forEach } from "lodash";
import { capitalizeLeadingText } from "../../../utils/textFormat";
// import filingMasters from "../../data/filingMasters.json";
import FilingMasterContext from "../../../context/filing-master/FilingMasterContext";
import AuthContext from "../../../context/auth/AuthContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import PostAwardFilingMasterComments from "./PostAwardFilingMasterComments";
import PostAwardAssociatedClient from "./PostAwardAssociatedClient";
// import { FilingMaster, FilingMasterComment } from "../../../types/FilingMaster";
import useDialog from "../../common/UseDialog";
import ReactLoading from "react-loading";
import { CircularProgress, Dialog, LinearProgress } from "@mui/material";
import * as xlsx from "xlsx";
import { saveAs } from "file-saver";
import FilingMasterAttachment from "./../../filing-master/FilingMasterAttachment";
import PostAwardFilingMasterHistory from "./PostAwardFilingMasterHistory";
import axios from "axios";
import IconButton from "@mui/material/IconButton";
import { Stack } from "@mui/material";
import { DateTime } from "luxon";
import Button from "@mui/material/Button";
import { GoogleMaterialIcon } from "../../ui/GoogleMaterialIcon";
import { Calendar } from "primereact/calendar";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import CustomDialog from "../../common/CustomDialog";
import { Button as PrimeButton } from "primereact/button";
import { ScrollPanel } from "primereact/scrollpanel";
import { OverlayPanel } from "primereact/overlaypanel";
import states from "../../../data/StateLookup.json";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ClientFilingMasterContext from "../../../context/client-filing-master/ClientFilingMasterContext";
import usePermission from "../../../usePermission";
import { useCommonDetailsContext } from "../../../context/Common/common";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const PostAwardFilingMasterList = () => {
  const { publishedBranding } = useCommonDetailsContext();
  const tableHeaderColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const primaryColor = tableHeaderColor;

  const { isMobile, mdUp } = useResponsive();
  const enableForzen = !isMobile
  const [selectedRows, setSelectedRows] = useState([]);
  const [jurisdiction, setJurisdiction] = useState([]);
  const [federalCategoriesLookup, setFederalCategoriesLookup] = useState([]);
  const [stateCategoriesLookup, setStateCategoriesLookup] = useState([]);
  const [categoriesLookup, setCategoriesLookup] = useState([]);
  const [stateLookup, setStateLookup] = useState([]);
  const [selectedmasters, setSelectedMasters] = useState(null);
  const [masters, setMasters] = useState([]);
  const [sortMaster, setSortMaster] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert1, setShowAlert] = useState(false);
  const [sortRecord, setSortRecord] = useState("Upcoming Due Dates");
  const [comments, setComments] = React.useState([]);
  const [clients, setClients] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const dataTableRef = useRef(null);
  const [showDeleteAlert, setShowdeleteAlert] = useState(false);
  const [value, setValue] = React.useState('1');
  const [selectedYear, setSelectedYear] = useState();
  const [currentYearVal, setCurrentYearVal] = useState()
  const [yearsList, setYearsList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const [isClearIcon, setIsClearIcon] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [categoryList, setCategoryList] = useState([])

  const [commentActivityHistory, setCommentActivityHistory] = React.useState([]);

  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });

  const {
    fetchConfigurations,
  } = clientFilingMasterContext;
  const createInitialFilters = () => ({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingId: { value: null, matchMode: FilterMatchMode.IN },
    // filingName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // filingFrequency: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // dueDayofFrequency: { value: null, matchMode: FilterMatchMode.IN },
    // stateInfo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // stateList: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // ruleInfo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // required: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // federalCategories: { value: null, matchMode: FilterMatchMode.IN },
    // stateCategories: { value: null, matchMode: FilterMatchMode.IN },
    jsidept: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //jsicontactName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jsicontactEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // juristiction: { value: null, matchMode: FilterMatchMode.IN },
    // whereToFile: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    required: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    jsicontactName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    whereToFile: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    dueDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
  });
  const [filters, setFilters] = useState(createInitialFilters);
  const [stateArray, setStateArray] = useState([]);
  const [postawardfederalArray, setPostAwardFederalArray] = useState([]);
  const [postawardstateArray, setPostAwardStateArray] = useState([]);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadStatusMsg, setDownloadStatusMsg] = useState("");
  const [showDownloadProgress, setShowDownloadProgress] = useState(false);

  const [showAttachments, setShowAttachments] = useState(false);
  const [attachments, setAttachments] = React.useState([]);

  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);

  const [expandedRows, setExpandedRows] = useState(null);

  const filingMasterContext = useContext(FilingMasterContext);
  const {
    setCurrentFilingMaster,
    getFilingMasters,
    setFilingMasters,
    filingMasters,
    postAwardFilingMasters,
    filingMasterLoaded,
    getFilingMasterComments,
    deleteDraftFilingMaster,
    createFilingMasterWorkflow,
    createPostAwardWorkflow,
    getBusinessCategories,
  } = filingMasterContext;

  // const [visibleApps, setVisibleApps] = useState(props.projects);
  const [showComments, setShowComments] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [masterCatFilter, setMasterCatFilter] = useState([]);
  const [upcomingCatFilter, setUpcomingCatFilter] = useState([]);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { authUser, userRoles } = authContext;
  const backToHome = () => {
    navigate("/");
  };

  const fetchFilingMasterComments = async (filingId) => {
    // console.log("@@Fetch FilingMasters1:", getFilingMasterComments);
    if (getFilingMasterComments) {
      // console.log("@@Fetch FilingMasters2:");
      try {
        const commentList = await getFilingMasterComments(filingId);
        setComments(() => commentList);
        // console.log("@@Fetch FilingMasters2 comments:", commentList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const fetchConfigs = async () => {
    if (fetchConfigurations) {
      let config = await fetchConfigurations();
      let startYear = config.find(
        (ele) => ele.configItem === 'StartYear'
      ).configItemValue;
      let currentYear = config.find(
        (ele) => ele.configItem === 'CurrentYear'
      ).configItemValue;
      startYear = parseInt(startYear);
      currentYear = parseInt(currentYear);
      const yearsInBetween = [];
      for (let year = startYear; year < currentYear; year++) {
        yearsInBetween.push(year);
      }
      setYearsList(yearsInBetween);
      setSelectedYear(currentYear - 1);
      setCurrentYearVal(currentYear)
      setLazyLoading(false)
      return
    }
  };

  const addComment = (rowData) => {
    if (rowData && rowData.filingId) {
      fetchFilingMasterComments(rowData.filingId);
      setShowComments(() => true);
      setSelectedMasters(rowData);
    } else if (selectedmasters && selectedmasters.filingId) {
      fetchFilingMasterComments(selectedmasters.filingId);
      setShowComments(() => true);
    } else {
      setAlertMessage("Please select a single Record");
      setShowAlert(true);
    }
  };
  const displayClients = () => {
    if (selectedmasters && selectedmasters.filingId) {
      fetchFilingMasterClients(selectedmasters.filingId);
      setShowClient(() => true);
    } else if (selectedmasters && selectedmasters.length > 1) {
      setAlertMessage("Please Select a single Filing Master Record");
      setShowAlert(true);
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };
  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    return state ? state.state : stateCode;
  };
  const formatDateMod = (dateString) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  const fetchMasterActive = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/FilingMaster/PostAwardFilingMasterList?RecordType=PostAward`
      );
      // console.log("fetchMasterActive res", res);
      return res.data; // Assuming the response contains the data you need
    } catch (error) {
      console.error("Error fetching tracker data:", error);
      throw error; // Propagate the error
    }
  };
  const fetchMasterHistory = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/FilingMaster/PostAwardFilingMasterList?RecordType=PostAward&Year=${selectedYear}`
      );
      // console.log("fetchMasterHistory res", res);
      return res.data; // Assuming the response contains the data you need
    } catch (error) {
      console.error("Error fetching tracker data:", error);
      throw error; // Propagate the error
    }
  };
  const exportExcel = async () => {
    if (showDownloadProgress) return;
    setShowDownloadProgress(true);
    setDownloadProgress(10);
    setDownloadStatusMsg("Fetching PostAward master records from server...");

    let currentProgress = 10;
    const progressTimer = setInterval(() => {
      if (currentProgress < 85) {
        currentProgress += Math.floor(Math.random() * 5) + 3;
        if (currentProgress > 85) currentProgress = 85;
        setDownloadProgress(currentProgress);
        setDownloadStatusMsg(`Fetching PostAward master records from server (${currentProgress}%)...`);
      }
    }, 750);

    try {
      const resList = await fetchMasterActive();
      clearInterval(progressTimer);

      if (!resList || resList.length === 0) {
        setShowDownloadProgress(false);
        setDownloadProgress(0);
        setAlertMessage("No data to download");
        setShowAlert(true);
        return;
      }

      setDownloadProgress(92);
      setDownloadStatusMsg(`Formatting ${resList.length.toLocaleString()} PostAward records...`);

      setTimeout(() => {
        const updDataPA = resList.flatMap((item) => {
          if (item.formattedFilingperiods && item.formattedFilingperiods !== "") {
            const dueDatesArray = item.formattedFilingperiods.split(',');
            return dueDatesArray.map((date) => ({
              ...item,
              individualFilingPeriods: date.trim(),
            }));
          } else {
            return [{ ...item, individualFilingPeriods: "" }];
          }
        });

        const renamedData = updDataPA.map((item) => {
          const stateMod = getStateName(item.stateInfo)
          const programName =
            item.programInfo && item.programInfo.length > 0
              ? item.programInfo[0].programName
              : '';
          let whoMustFileFederalMod = '';
          let whoMustFileinStateMod = '';

          const _filingPeriods = item.filingPeriods ? item.filingPeriods.map(period => (
            `${formatDateMod(new Date(period.startDate))}-${formatDateMod(new Date(period.endDate))}`
          )).join(',\n') : '';

          if (item.juristiction === "Federal") {
            whoMustFileFederalMod = programName;
          } else if (item.juristiction === "State") {
            whoMustFileinStateMod = programName;
          }

          return {
            "Filing Name": item.filingName,
            "Filing Frequency ": item.filingFrequency,
            "State ": stateMod,
            "Rule Info": item.ruleInfo,
            "Required ": item.required,
            "Filing Periods": _filingPeriods,
            "Who Must File Federal": whoMustFileFederalMod,
            "Who Must File in state": whoMustFileinStateMod,
            "JSI Staff": item.jsicontactName,
            "Jurisdiction ": item.juristiction,
            "Where to File": item.whereToFile,
            "RecordType": item.recordType,
            "Notes": item.notes,
          };
        });

        const worksheet = xlsx.utils.json_to_sheet(renamedData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
          compression: false,
        });

        setDownloadProgress(100);
        setDownloadStatusMsg("Download complete!");
        saveAsExcelFile(excelBuffer, "filingmaster");

        setTimeout(() => {
          setShowDownloadProgress(false);
          setDownloadProgress(0);
          setDownloadStatusMsg("");
        }, 400);
      }, 10);
    } catch (error) {
      clearInterval(progressTimer);
      console.log("error", error);
      setShowDownloadProgress(false);
      setDownloadProgress(0);
      setAlertMessage("Error downloading Excel file");
      setShowAlert(true);
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    });

    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  };

  const exportExcelHistory = async () => {
    if (showDownloadProgress) return;
    setShowDownloadProgress(true);
    setDownloadProgress(10);
    setDownloadStatusMsg("Fetching history records from server...");

    let currentProgress = 10;
    const progressTimer = setInterval(() => {
      if (currentProgress < 85) {
        currentProgress += Math.floor(Math.random() * 5) + 3;
        if (currentProgress > 85) currentProgress = 85;
        setDownloadProgress(currentProgress);
        setDownloadStatusMsg(`Fetching history records from server (${currentProgress}%)...`);
      }
    }, 750);

    try {
      const resList = await fetchMasterHistory();
      clearInterval(progressTimer);

      if (!resList || resList.length === 0) {
        setShowDownloadProgress(false);
        setDownloadProgress(0);
        setAlertMessage("No data to download");
        setShowAlert(true);
        return;
      }

      setDownloadProgress(92);
      setDownloadStatusMsg(`Formatting ${resList.length.toLocaleString()} history records...`);

      setTimeout(() => {
        const updDataPA = resList.flatMap((item) => {
          if (item.formattedFilingperiods && item.formattedFilingperiods !== "") {
            const dueDatesArray = item.formattedFilingperiods.split(',');
            return dueDatesArray.map((date) => ({
              ...item,
              individualFilingPeriods: date.trim(),
            }));
          } else {
            return [{ ...item, individualFilingPeriods: "" }];
          }
        });

        const renamedData = updDataPA.map((item) => {
          const stateMod = getStateName(item.stateInfo)
          const programName =
            item.programInfo && item.programInfo.length > 0
              ? item.programInfo[0].programName
              : '';
          let whoMustFileFederalMod = '';
          let whoMustFileinStateMod = '';

          const _filingPeriods = item.filingPeriods ? item.filingPeriods.map(period => (
            `${formatDateMod(new Date(period.startDate))}-${formatDateMod(new Date(period.endDate))}`
          )).join(',\n') : '';

          if (item.juristiction === "Federal") {
            whoMustFileFederalMod = programName;
          } else if (item.juristiction === "State") {
            whoMustFileinStateMod = programName;
          }

          return {
            "Filing Name": item.filingName,
            "Filing Frequency ": item.filingFrequency,
            "State ": stateMod,
            "Rule Info": item.ruleInfo,
            "Required ": item.required,
            "Filing Periods": _filingPeriods,
            "Who Must File Federal": whoMustFileFederalMod,
            "Who Must File in state": whoMustFileinStateMod,
            "JSI Staff": item.jsicontactName,
            "Jurisdiction ": item.juristiction,
            "Where to File": item.whereToFile,
            "RecordType": item.recordType,
            "Notes": item.notes,
          };
        });

        const worksheet = xlsx.utils.json_to_sheet(renamedData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
          compression: false,
        });

        setDownloadProgress(100);
        setDownloadStatusMsg("Download complete!");
        saveAsExcelFileHistory(excelBuffer, "filingmaster");

        setTimeout(() => {
          setShowDownloadProgress(false);
          setDownloadProgress(0);
          setDownloadStatusMsg("");
        }, 400);
      }, 10);
    } catch (error) {
      clearInterval(progressTimer);
      console.log("error", error);
      setShowDownloadProgress(false);
      setDownloadProgress(0);
      setAlertMessage("Error downloading Excel file");
      setShowAlert(true);
    }
  };

  const saveAsExcelFileHistory = (buffer, fileName) => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    });

    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  };
  const fetchFilingMasterAttachments = async (filingId) => {
    // console.log("fetchFilingMasterAttachments props", filingId);
    try {
      const attachmentList = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
      );
      setAttachments(() => attachmentList.data.data);
      // console.log("fetchFilingMasterAttachments res", attachmentList);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  const fetchFilingMasterClients = async (filingId) => {
    // console.log("fetchFilingMasterClients props", filingId);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterList${filingId}`
      );
      const clientsData = response.data;
      // console.log("Customer", clientsData);
      const customerArray = clientsData.customer;
      setClients(customerArray);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  // console.log("CLIENTSDATA", clients);
  const displayAttachments = async (rowData) => {
    if (rowData && rowData.filingId) {
      fetchFilingMasterAttachments(rowData.filingId);
      setShowAttachments(() => true);
      setSelectedMasters(null);
    } else if (selectedmasters && selectedmasters.filingId) {
      fetchFilingMasterAttachments(selectedmasters.filingId);
      setShowAttachments(() => true);
    } else if (selectedmasters && selectedmasters.length > 1) {
      setAlertMessage("Please Select a single Filing Master Record");
      setShowAlert(true);
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };

  const fetchFilingMasterHistory = async (filingId) => {
    // console.log("fetchFilingMasterHistory props", filingId);
    try {
      let res = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAudit?FilingId=${filingId}`
      );
      let history = res.data.data;
      // console.log("fetchFilingMasterHistory props", res.data.data, history);
      setActivityHistory(() => history);
      // console.log("fetchFilingMasterHistory res", history);
    } catch (error) {
      console.log("@@Error:", error);
    }
    try {
      const history = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterCommentsAudit?FilingId=${filingId}`
      );
      setCommentActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };



  const displayHistory = async () => {
    if (selectedmasters && selectedmasters.filingId) {
      fetchFilingMasterHistory(selectedmasters.filingId);
      setShowHistory(() => true);
    } else if (selectedmasters && selectedmasters.length > 1) {
      setAlertMessage("Please Select a single Filing Master Record");
      setShowAlert(true);
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };

  const closeComments = () => {
    // console.log("Toggling Show Filter", showComments);
    setShowComments(() => false);
  };
  const closeClient = () => {
    // console.log("Toggling Show Filter", showClient);
    setShowClient(() => false);
  };

  const closeAttachments = () => {
    // console.log("Toggling Show Filter", showAttachments);
    setShowAttachments(() => false);
  };

  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };

  const closeDeleteAlert = () => {
    setShowdeleteAlert(false)
  }

  const handleSubmit = () => {
    // console.log("Submitting Delete....", selectedmasters);
    // deleteCategory();
    deleteMasterRecord();
  };

  const closeConfirm = () => {
    // console.log("Cancelling....");
    // setSelectedRowForDelete(null);
    // navigate("/");
  };

  const {
    AlertDialog: ConfirmDialog,
    showDialog,
    closeDialog,
  } = useDialog({
    onSubmit: handleSubmit,
    onClose: closeConfirm,
    confirmVariant: "destructive",
    cancelVariant: "tertiary",
  });

  const { AlertDialog, showDialog: showAlert } = useDialog({});

  const handleDelete = () => {
    if (selectedmasters) {
      showDialog(
        "Confirmation",
        <Typography>
          Are you sure you want to delete this{" "}
          <Typography fontWeight="bold" component="span">
            {selectedmasters.filingName}
          </Typography>{" "}
          record?{" "}
        </Typography>,
        "confirm"
      );
    }
    else {
      showAlert("Info", "Please Select a Master Record", "info");
      closeDialog();
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;
    // console.log("_filters", _filters);
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const jusrisdictionItemTemplate = (option) => {
    // console.log("##TOptions:", option);
    return (
      <div className="flex align-items-center">
        <span>{option}</span>
      </div>
    );
  };


  const requiredArray = ["True", "False"];

  const requiredRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (!masterCatFilter.required && options.filterModel.value) {
      // console.log("requiredRowFilterTemplate filterModel",options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }
    return (
      <Dropdown
        value={masterCatFilter.required || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          ;
          setMasterCatFilter((prev) => {
            return { ...prev, required: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const jusrisdictionArray = ["Federal", "State", "Both"];

  const jurisdictionRowFilterTemplate = (options) => {
    // console.log("##Options:", options);

    if (!masterCatFilter.jurisdiction && options.filterModel.value) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <MultiSelect
        value={options.value ? options.value : ""}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setMasterCatFilter((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const customCategoryFilter = (value, filter) => {
    // console.log("##Filter value:", value);
    // console.log("##Filter filter:", filter);
    filter.filterApplyCallback(value);
    // return value.some((cateogory) => cateogory.includes(filter)); // check if at least one skill matches filter
  };

  // const CellListDisplayFederal = (rowData, field) => {
  //   const op = useRef(null);

  //   let displayFederal = Array.isArray(rowData[field])
  //     ? rowData[field].join(", ")
  //     : rowData[field];
  //   console.log("CellListDisplayFederal", field, rowData);

  //   const categories = rowData[field]
  //     ? field === "federalCategories"
  //       ? rowData.businessCategory.map((ele) => ele.businessCategoryName)
  //       : rowData.businessCategory 
  //         .filter((ele) => ele.state === rowData.stateInfo)
  //         .map((ele) => ele.businessCategoryName)
  //     : [];
  //   console.log("CellListDisplayFederal categories--", categories);

  //   let name =
  //     field === "federalCategories"
  //       ? "Who Must File Federal"
  //       : "Who Must File in State";

  //   return (
  //     <div
  //       className="tableBtn"
  //       id={`${field}+${rowData.fileTrackingId}`}
  //       style={{
  //         width: "inherit",
  //       }}
  //     >
  //       <PrimeButton
  //         onClick={(e) => op.current.toggle(e)}
  //         text
  //         style={{
  //           width: "100%",
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: "inherit",
  //             overflow: "hidden",
  //             textOverflow: "ellipsis",
  //             color: "black",
  //           }}
  //         >
  //           {displayFederal}
  //         </div>
  //       </PrimeButton>
  //       <OverlayPanel ref={op} showCloseIcon style={{ padding: "0rem 1rem" }}>
  //         {name}
  //         <ScrollPanel style={{ maxWidth: "25rem", maxHeight: "20rem" }}>
  //           <ul>
  //             {categories.map((ele) => (
  //               <li>{ele}</li>
  //             ))}
  //           </ul>
  //         </ScrollPanel>
  //       </OverlayPanel>
  //     </div>
  //   );
  // };

  const cellListDisplayName = (rowData) => {
    return (
      <LightTooltip title={rowData.filingName}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: tableHeaderColor,
            cursor: "pointer",
            transition: "font-weight 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.fontWeight = '600';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.fontWeight = '400';
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);
    return (
      <LightTooltip title={ruleInfoValue}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ruleInfoValue}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayNotes = (rowData) => {
    const notesUrl = rowData.notes;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!notesUrl) return null;

    const formattedText = notesUrl.replace(
      urlRegex,
      '<a style="color:#0000FF;" href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
    );

    return (
      <LightTooltip
        arrow
        title={
          <div
            style={{
              maxWidth: "350px",
              maxHeight: "250px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              padding: "4px",// Added top/bottom & left/right padding
              fontWeight: "normal",   // Remove bold
              lineHeight: "1.5",      // Better readability
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        }
      >
        <div
          style={{
            width: "100%",
            maxWidth: "44rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </LightTooltip>
    );
  };

  const cellListDisplayWhereToFile = (rowData) => {
    const value = rowData.whereToFile?.trim();
    const urlRegex = /(https?:\/\/[^\s]+)/gi;
    const urlTestRegex = /(https?:\/\/[^\s]+)/i;

    if (!value) return value;

    const parts = value.split(urlRegex);

    return (
      <LightTooltip
        title={
          <>
            {parts.map((part, index) =>
              urlTestRegex.test(part) ? (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                  {part}
                </a>
              ) : (
                part
              )
            )}
          </>
        }
      >
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {parts.map((part, index) =>
            urlTestRegex.test(part) ? (
              <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                {part}
              </a>
            ) : (
              part
            )
          )}
        </div>
      </LightTooltip>
    );
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  const cellListDisplayState = (rowData) => {
    return rowData["stateCategories"]?.join(", ");
  };

  const formatDate = (value) => {
    return value !== null
      ? value.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      : null;
  };

  const cellListDisplayDueDate = (rowData) => {
    // console.log("cellEditorBody", rowData["dueDate"]);
    return formatDate(rowData.dueDate);
  };

  const masterCategoryFilter = (options, field) => {
    // console.log("OPTIONCHECK", options, "field", field);

    let optionsList = [];
    masters
      .map((item) => item[field])
      .filter(Boolean)
      .map((item) => {
        if (item.includes(",")) {
          // console.log("spliited_item", item);
          item.split(",").map((subItem) => {
            optionsList.push(subItem && subItem.trim());
          });
        } else {
          optionsList.push(item.trim());
        }
      });
    optionsList = optionsList
      .filter((item, i) => {
        return i === optionsList.lastIndexOf(item);
      })
      .sort();

    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          // console.log(
          //   "##federalFilterElement#:",
          //   options.filterModel.matchMode
          // );
          masters.forEach((item) => {
            if (e.value.some((category) => item[field]?.includes(category))) {
              values.push(item[field]);
            }
          });
          values = values.filter((item, i) => {
            return i === values.lastIndexOf(item);
          });
          // console.log(e.value, "federalFilterElement", values, options);
          options.filterApplyCallback(values);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          // console.log(
          //   "##federalFilterElement#:",
          //   options.filterModel.matchMode
          // );
          if (options.filterModel.matchMode === "notContains") {
            masters.forEach((item) => {
              if (item[field]?.includes(e.value)) {
                item[field] !== undefined && values.push(item[field]);
              }
            });
            // console.log("federalFilterElement notContains", values);
            values = values.filter((item, i) => {
              return i === values.lastIndexOf(item);
            });
          } else if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          }
          // console.log("federalFilterElement", e.value, values);
          options.filterApplyCallback(values);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const upcomingCategoryFilter = (options, field) => {
    // console.log("OPTIONCHECK", options, "field", field);

    let optionsList = [];
    sortMaster
      .map((item) => item[field])
      .filter(Boolean)
      .map((item) => {
        if (item.includes(",")) {
          //console.log("spliited_item", item);
          item.split(",").map((subItem) => {
            optionsList.push(subItem && subItem.trim());
          });
        } else {
          optionsList.push(item.trim());
        }
      });
    optionsList = optionsList
      .filter((item, i) => {
        return i === optionsList.lastIndexOf(item);
      })
      .sort();

    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={upcomingCatFilter[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, sortMaster);
          setUpcomingCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          // console.log(
          //   "##federalFilterElement#:",
          //   options.filterModel.matchMode
          // );
          sortMaster.forEach((item) => {
            if (e.value.some((category) => item[field]?.includes(category))) {
              values.push(item[field]);
            }
          });
          values = values.filter((item, i) => {
            return i === values.lastIndexOf(item);
          });
          // console.log(e.value, "federalFilterElement", values, options);
          options.filterApplyCallback(values);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={upcomingCatFilter[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, sortMaster);
          setUpcomingCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          // console.log(
          //   "##federalFilterElement#:",
          //   options.filterModel.matchMode
          // );
          if (options.filterModel.matchMode === "notContains") {
            sortMaster.forEach((item) => {
              if (item[field]?.includes(e.value)) {
                item[field] !== undefined && values.push(item[field]);
              }
            });
            // console.log("federalFilterElement notContains", values);
            values = values.filter((item, i) => {
              return i === values.lastIndexOf(item);
            });
          } else if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          }
          // console.log("federalFilterElement", e.value, values);
          options.filterApplyCallback(values);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const fetchFilingMasters = async () => {

    // console.log("@@Fetch FilingMasters1:", getFilingMasters);
    if (getFilingMasters) {

      // console.log("@@Fetch FilingMasters2:");
      try {
        let formData;
        if (value === "1") {
          formData = {
            recordType: "PostAward",
          };
        } else {
          formData = {
            recordType: "PostAward",
            year: selectedYear
          };
          // console.log("formData",formData);
        }
        const custList = await getFilingMasters(formData);
        // console.log("@@FilingMasters:", custList);
        const _jusrisdictions = custList.map((item) =>
          item.juristiction ? item.juristiction : ""
        );
        const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
        // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
        setJurisdiction(_uniqJurisdictions);
        //  setFilingMasterList(custList)
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
    // if (getBusinessCategories) {
    //   try {
    //     const catList = await getBusinessCategories();
    //     const catListNames = _.map(catList, "businessCategoryName");
    //     console.log("@@Unique Cateogry:", catListNames);
    //     setCategoriesLookup(catListNames);
    //   } catch (error) {
    //     console.log("@@Error:", error);
    //   }
    // }
  };

  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => {
          // console.log("dateFilterTemplate", e.value, options.index);
          return options.filterCallback(e.value, options.index);
        }}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    // console.log("stateRowFilterTemplate:", options, stateArray);
    if (!masterCatFilter.stateList && options.filterModel.value) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = [];
      options.value = [];
    }
    return options.filterModel.matchMode === "contains" ? (
      <MultiSelect
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("stateRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          // options.filterApplyCallback(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("stateRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          //options.filterApplyCallback(values);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    );
  };
  const postawardFederalRowFilterTemplate = (options) => {
    // console.log(" postawardFederalRowFilterTemplate:", options, postawardfederalArray);
    let optionsListSorted = postawardfederalArray.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    if (!masterCatFilter.federalCategories && options.filterModel.value) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = [];
      options.value = [];
    }

    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter.federalCategories || []}
        options={postawardfederalArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardFederalRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, federalCategories: e.value };
          });
          //options.filterApplyCallback(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.federalCategories || []}
        options={postawardfederalArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardFederalRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, federalCategories: e.value };
          });
          //options.filterApplyCallback(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };
  const postawardStateRowFilterTemplate = (options) => {
    // console.log(" postawardStateRowFilterTemplate:", options, postawardstateArray);
    if (!masterCatFilter.stateCategories && options.filterModel.value) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = [];
      options.value = [];
    }
    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter.stateCategories || []}
        options={postawardstateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardStateRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, stateCategories: e.value };
          });
          //options.filterApplyCallback(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.stateCategories || []}
        options={postawardstateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardStateRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, stateCategories: e.value };
          });
          //options.filterApplyCallback(values);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };

  const cellEditor = (options) => {
    // console.log("##Editor Options:", options);
    return (
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Calendar
          value={options.value ? new Date(options.value) : options.value}
          onChange={(e) => options.editorCallback(e.value)}
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          mask="99/99/9999"
        />
      </Stack>
    );
  };

  useEffect(() => {
    if (filingMasterLoaded) {
      // console.log("Show Table Data", postAwardFilingMasters);
    }
    //eslint-disable-next-line
  }, [filingMasterLoaded]);

  const onRowSelect = (e) => {
    // console.log("@@RowSelect:", e);
  };

  // useEffect(() => {
  // let list = states.map((ele) => ele.state);
  // setStateArray(list);
  // fetchFilingMasters();

  //eslint-disable-next-line
  // }, []);

  const handleChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  useEffect(() => {
    // console.log("state", selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    // if (postAwardFilingMasters) {
    //   try {

    //     console.log("Orig postAwardFilingMasters...", postAwardFilingMasters);
    //     let allCats = [];
    //     let fedLookup = [];
    //     let stateCatLookup = [];
    //     let federalPostAwardLookup = [];
    //     let statePostAwardLookup = [];


    //     // const postAwardFilingMasters = postAwardFilingMasters && postAwardFilingMasters.filter(item => item.recordType === "PostAward");

    //     // console.log("postAwardFilingMasters",postAwardFilingMasters)

    //     const updFilingMasters = postAwardFilingMasters
    //       .filter((record) => !record.changesInprogress)
    //       .map((item) => {
    //         // console.log(`filingMasters ...`, item);

    //         const _stateList = getStateName(item.stateInfo);
    //         console.log("ProgramInfo", item.programInfo);
    //         const programName = item.programInfo && item.programInfo.length > 0
    //           ? item.programInfo[0].programName
    //           : '';


    //         console.log("ProgramName", programName);

    //         const toLocalDateString = (date) => {
    //           console.log("dateCheck", date);
    //           return date.toLocaleDateString('en-US', {
    //             month: '2-digit',
    //             day: '2-digit',
    //             year: 'numeric',
    //           });
    //         };
    //         const _filingPeriods = item.filingPeriods.map(period => (
    //           `${toLocalDateString(new Date(period.startDate))}-${toLocalDateString(new Date(period.endDate))}`
    //         )).join(', ');
    //         console.log("filingpCheck", _filingPeriods);
    //         // const categories = _categories.join(", ");
    //         // console.log(`filingMasters ${item.filingMasters} cat...`, categories);
    //         if (item.juristiction?.includes("Federal")) {
    //           // setFederalCategoriesLookup((old) => [...old, categories])

    //           // const _categories = _.map(
    //           //   item.businessCategory,
    //           //   "businessCategoryName"
    //           // ).join(", ");
    //           if (
    //             !federalPostAwardLookup.includes(programName) &&
    //             programName !== ""
    //           ) {
    //             // setPostAwardFederalArray([...postawardfederalArray,programName]);
    //             federalPostAwardLookup.push(programName);
    //           }
    //           allCats.push(programName);
    //           fedLookup.push(programName);
    //           setPostAwardFederalArray(federalPostAwardLookup);

    //           return {
    //             ...item,
    //             federalCategories: programName,
    //             stateList: _stateList,
    //             formattedFilingperiods: _filingPeriods

    //           };
    //           console.log("item.programName", programName);
    //         } else if (item.juristiction?.includes("Both")) {
    //           // setFederalCategoriesLookup((old) => [...old, categories])

    //           // const _categories = _.map(
    //           //   item.businessCategory,
    //           //   "businessCategoryName"
    //           // ).join(", ");
    //           if (
    //             !federalPostAwardLookup.includes(programName) &&
    //             programName !== ""
    //           ) {
    //             // setPostAwardFederalArray([...postawardfederalArray,programName]);
    //             federalPostAwardLookup.push(programName);
    //           }

    //           if (
    //             !statePostAwardLookup.includes(programName) &&
    //             programName !== ""
    //           ) {
    //             statePostAwardLookup.push(programName);
    //           }

    //           allCats.push(programName);
    //           fedLookup.push(programName);
    //           setPostAwardFederalArray(federalPostAwardLookup);
    //           stateCatLookup.push(programName);
    //           setStateCategoriesLookup((old) => [...old, programName]);
    //           setPostAwardStateArray(statePostAwardLookup);

    //           return {
    //             ...item,
    //             federalCategories: programName,
    //             stateCategories: programName,
    //             stateList: _stateList,
    //             formattedFilingperiods: _filingPeriods
    //           };
    //           console.log("item.programName", programName);
    //         } else {
    //           // console.log(
    //           //   "stateCategories: props",
    //           //   item.stateInfo,
    //           //   item.businessCategory
    //           // );

    //           const categoriesState = item.businessCategory.filter(
    //             (ele) => ele.state === item.stateInfo
    //           );
    //           console.log(
    //             "stateCategories: filter",
    //             item.filingName,
    //             categoriesState
    //           );
    //           if (
    //             !statePostAwardLookup.includes(programName) &&
    //             programName !== ""
    //           ) {
    //             // setPostAwardFederalArray([...postawardfederalArray,programName]);
    //             statePostAwardLookup.push(programName);
    //           }
    //           // const _categories = categoriesState
    //           //   .map((ele) => ele.businessCategoryName)
    //           //   .join(", ");
    //           // console.log("stateCategories: join", _categories);

    //           allCats.push(programName);
    //           stateCatLookup.push(programName);
    //           setStateCategoriesLookup((old) => [...old, programName]);
    //           setPostAwardStateArray(statePostAwardLookup);
    //           return {
    //             ...item,
    //             stateCategories: programName,
    //             stateList: _stateList,
    //             formattedFilingperiods: _filingPeriods

    //           };
    //         }
    //       });
    //     console.log("Updated filingMasters...", updFilingMasters);
    //     // setData(updCustomers);

    //     setFederalCategoriesLookup(Array.from(new Set(fedLookup)));
    //     setStateCategoriesLookup(Array.from(new Set(stateCatLookup)));
    //     setCategoriesLookup(Array.from(new Set(allCats)));


    //     // setStateCategoriesLookup((old) => new Set(old).values());
    //     setMasters(updFilingMasters);

    //   } finally {
    //     setIsLoading(false)
    //   }
    // }
    //eslint-disable-next-line
  }, [postAwardFilingMasters]);

  useEffect(() => {
    // upcomingDueDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masters]);

  // const upcomingDueDates = () => {
  //   console.log("upcomingDueDates", masters);
  //   let upcomingDates = masters.filter((ele) => {
  //     let currentYear = new Date().getFullYear();
  //     if (ele.filingPeriods.length > 0) {
  //       let isUpcomingDate = ele.filingPeriods
  //         .filter((d) => new Date(d.dueDate).getFullYear() === currentYear)
  //         .map((d) => d.dueDate);
  //       console.log(
  //         "upcomingDueDates isUpcomingDate",
  //         currentYear,
  //         isUpcomingDate,
  //         ele.upcomingDueDates
  //       );
  //       if (isUpcomingDate.length > 0) {
  //         ele.upcomingDueDates = isUpcomingDate;
  //         return ele;
  //       }
  //     }
  //   });
  //   console.log("upcomingDueDates", upcomingDates);

  //   console.log("LODASH", upcomingDates);
  //   let id = 0;
  //   let upcomingDatesFlat = _.flatMap(upcomingDates, (n) => {
  //     console.log("LODASH", n);
  //     return n.upcomingDueDates.map((ele) => {
  //       id++;
  //       // let date = toLocalTime2(ele);
  //       return {
  //         ...n,
  //         //  dueDate: ele !== null ? new Date(date) : null,
  //         dueDate: ele !== null ? new Date(ele) : null,
  //         rowId: id,
  //       };
  //     });
  //   });
  //   console.log("LODASH", upcomingDatesFlat);

  //   let sortedData = upcomingDatesFlat.sort(function (a, b) {
  //     var date1 = new Date(a.dueDate);
  //     var date2 = new Date(b.dueDate);
  //     console.log(
  //       "upcomingDueDates compare",
  //       a.dueDate,
  //       b.dueDate,
  //       date1 - date2
  //     );
  //     return date1 - date2;
  //   });
  //   console.log("upcomingDueDates", sortedData);
  //   setSortMaster(sortedData);
  // };

  // const sortRecords = () => {
  //   console.log("sortRecords", masters, sortMaster);
  //   if (sortRecord === "Upcoming Due Dates") {
  //     setSortRecord("Clear");
  //     upcomingDueDates();
  //     setMasterCatFilter([]);
  //   } else if (sortRecord === "Clear") {
  //     setSortMaster([]);
  //     setSortRecord("Upcoming Due Dates");
  //     setMasterCatFilter([]);
  //   }
  // };
  useEffect(() => {
    if (value) {
      // fetchFilingMasters();
      setRecordsInView(0);
      setIsLoading(true);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setRefreshRecordList(true);
    }
  }, [value]);
  useEffect(() => {
    if (value === "2") {
      // fetchFilingMasters()
      setRecordsInView(0);
      setIsLoading(true);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setRefreshRecordList(true);
    };
  }, [selectedYear]);

  const fetchBusinessCategories = async () => {
    // console.log("@@Fetch BusinessCategories:", getBusinessCategories);
    if (getBusinessCategories) {
      // console.log("@@Fetch BusinessCategories:");
      try {
        let list = []
        const resList = await getBusinessCategories();
        // console.log("@@BusinessCategories:", resList);
        list = resList.map((item) => item.businessCategoryName).sort()
        // console.log("@@BusinessCategories: list", list);
        setCategoryList(() => list);
        return
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const initialLoadPage = async () => {
    setLazyLoading(true)
    await fetchConfigs();
    let list = states.map((ele) => ele.state);
    setStateArray(list);
    fetchBusinessCategories()
    if (masters.length <= 0 && !lazyLoading) {
      setRecordsInView(0)
      setRefreshRecordList(true)
    }
  }

  useEffect(() => {
    initialLoadPage();
    return () => {
      setFilingMasters([])
    }
  }, []);

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const normalizeFilterValueForBackend = (field, value) => {
    if (!Array.isArray(value)) {
      return value;
    }

    const values = value.filter((item) => item !== null && item !== undefined && item !== "");

    if (values.length === 0) {
      return null;
    }

    // Backend filter supports bool only; selecting both means "Any"
    if (field === "required") {
      if (values.length > 1) {
        return null;
      }
      return values[0];
    }

    // filingFrequency supports multi-select in UI; handled as multi-filter API calls in loadRecordsList
    if (field === "filingFrequency") {
      return values;
    }

    // Backend accepts single string for these fields
    if (field === "juristiction") {
      if (values.length > 1) {
        return null;
      }
      return values[0];
    }

    return values;
  };

  const handleFilterApply = (filterConfig) => {
    console.log("Filter applied:", filterConfig);
    const normalizedValue = normalizeFilterValueForBackend(
      filterConfig.field,
      filterConfig.value
    );
    const updatedFilters = activeFilters.filter((f) => f.field !== filterConfig.field);

    if (normalizedValue === null) {
      setActiveFilters(updatedFilters);
      let _filters = { ...filters };
      if (filterConfig.field && _filters[filterConfig.field]) {
        _filters[filterConfig.field].constraints[0].value = null;
        setFilters(_filters);
        onFilterChange({ filters: _filters });
      }
      return;
    }

    const newFilter = {
      ...filterConfig,
      value: normalizedValue,
      displayValue: Array.isArray(normalizedValue) ? normalizedValue : [normalizedValue],
      id: Date.now()
    };
    setActiveFilters([...updatedFilters, newFilter]);

    let _filters = { ...filters };
    if (filterConfig.field && _filters[filterConfig.field]) {
      _filters[filterConfig.field].constraints[0].value = normalizedValue;
      _filters[filterConfig.field].constraints[0].matchMode = filterConfig.matchMode;
      setFilters(_filters);
      onFilterChange({ filters: _filters });
    }
  };

  const handleFilterClear = () => {
    setActiveFilters([]);
    setFilters(createInitialFilters());
    setMasterCatFilter([]);
    setUpcomingCatFilter([]);
    setGlobalFilterValue("");
    setIsClearIcon(false);
    setSelectedMasters(null);
    if (search.current) {
      search.current.value = "";
    }
    setRecordsInView(0);
    setIsLoading(true);
    setMasters([]);
    setFilingMasters([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setRefreshRecordList(true);
  };

  const removeFilter = (filterId) => {
    const filterToRemove = activeFilters.find((filter) => filter.id === filterId);
    const updatedFilters = activeFilters.filter((filter) => filter.id !== filterId);
    setActiveFilters(updatedFilters);

    if (!filterToRemove?.field || !filters[filterToRemove.field]) {
      return;
    }

    let _filters = { ...filters };
    _filters[filterToRemove.field].constraints[0].value = null;
    setFilters(_filters);

    setMasterCatFilter((prev) => {
      if (!prev || typeof prev !== "object") {
        return [];
      }
      const updated = { ...prev };
      delete updated[filterToRemove.field];
      return updated;
    });

    onFilterChange({ filters: _filters });
  };

  const formatFilterLabel = (field) => {
    if (!field) {
      return "";
    }

    const filterLabelMap = {
      approverName: "Approver Name",
      filingName: "Filing Name",
      filingFrequency: "Filing Frequency",
      stateList: "State",
      ruleInfo: "Rule Info",
      required: "Required",
      federalCategories: "Who Must File Federal",
      stateCategories: "Who Must File In State",
      jsicontactName: "JSI Staff",
      awardTypeName: "Award Type",
      awardingAgencyName: "Award Agency",
      juristiction: "Jurisdiction",
      whereToFile: "Where To File",
      dueDate: "Due Date",
      notes: "Notes",
      workflowStatus: "Status",
    };

    if (filterLabelMap[field]) {
      return filterLabelMap[field];
    }

    return field
      .replace(/[_-]+/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatActiveFilterValue = (value) => {
    if (Array.isArray(value)) {
      return value
        .map((item) => (item === true ? "True" : item === false ? "False" : item))
        .join(", ");
    }

    if (value === true) {
      return "True";
    }

    if (value === false) {
      return "False";
    }

    return value;
  };

  const search = useRef()

  const applyGlobalFilter = (e) => {
    // console.log("applyGlobalFilter",e,search);
    let _filters = { ...filters };
    if (filters.global.value === null) {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
    } else {
      _filters["global"].value = null;
      search.current.value = ""
      setIsClearIcon(false);
    }
    setFilters(_filters);
    onFilterChange({ filters: _filters });
  };

  const renderHeader = () => {
    return (
      <Grid container direction="column" spacing={1} sx={{ mb: 1 }}>
        {/* ROW 1 — TITLE */}
        <Grid item >
          <Grid container alignItems="center">
            <ArrowBackIosNewIcon
              style={{ marginRight: "10px", cursor: "pointer" }}
              onClick={backToHome}
            />

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "inherit"
              }}
            >
              {value === "1"
                ? `POST AWARD LIST ACTIVE (${totalRecords})`
                : `POST AWARD LIST HISTORY (${totalRecords})`}
            </Typography>
          </Grid>
        </Grid>
        {/* ROW 2 — CONTROLS */}

        {/* YEAR + SEARCH */}
        <Grid item>
          <Grid
            container
            spacing={2}
            alignItems="center"
            flexWrap="wrap"
            justifyContent="space-between"
          >
            {/* FILTER + CHIPS */}
            <Grid item>
              <TrackNowButton
                variant="secondary"
                size="small"
                onClick={handleFilterClick}
                sx={{
                  fontSize: "12px",
                  padding: "4px 12px",
                  minHeight: "28px",
                }}
              >
                + Filter
              </TrackNowButton>
            </Grid>
            {value === "2" && (
              <FormControl size="small" sx={{ minWidth: 120, marginLeft: "10px" }}>
                <InputLabel id="pa-year-select-label">Year</InputLabel>
                <Select
                  labelId="pa-year-select-label"
                  value={selectedYear}
                  label="Year"
                  onChange={(event) => handleYearChange(event)}
                  sx={{
                    backgroundColor: tokens.colors.offWhite,
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(0, 0, 0, 0.23)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${tableHeaderColor} !important`,
                      borderWidth: "1px !important",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${tableHeaderColor} !important`,
                      borderWidth: "1px !important",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        "& .MuiMenuItem-root": {
                          "&:hover": {
                            backgroundColor: `${alpha(tableHeaderColor, 0.12)} !important`,
                          },
                          "&.Mui-selected": {
                            backgroundColor: `${alpha(tableHeaderColor, 0.18)} !important`,
                            "&:hover": {
                              backgroundColor: `${alpha(tableHeaderColor, 0.24)} !important`,
                            },
                          },
                        },
                      },
                    },
                  }}
                >
                  {yearsList.map((year) => (
                    <MenuItem value={year} key={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <Grid item>
              <TextField
                inputRef={search}
                placeholder="Search Filing Name..."
                size="small"
                sx={{
                  width: { xs: "100%", sm: 280 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "20px",
                    backgroundColor: tokens.colors.offWhite,
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(0, 0, 0, 0.23)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${tableHeaderColor} !important`,
                      borderWidth: "1px !important",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${tableHeaderColor} !important`,
                      borderWidth: "1px !important",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={applyGlobalFilter}
                        edge="end"
                        size="small"
                      >
                        {isClearIcon ? <ClearIcon style={{ color: tableHeaderColor }} /> : <SearchIcon style={{ color: tableHeaderColor }} />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        {activeFilters.length > 0 && (
          <Grid mb={1} item>
            {activeFilters.map((filter) => (
              <div
                key={filter.id}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: tokens.colors.offWhite,
                  border: "1px solid #ccc",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  minHeight: "28px",
                  fontSize: "13px",
                  color: "#333",
                  maxWidth: "100%",
                }}
              >
                <span>
                  {formatFilterLabel(filter.field)}:{" "}
                  {formatActiveFilterValue(filter.value)}
                </span>

                <button
                  onClick={() => removeFilter(filter.id)}
                  style={{
                    marginLeft: "4px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#666",
                    fontSize: "14px",
                    lineHeight: 1,
                    padding: "0",
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </Grid>
        )}
      </Grid>
    );
  };

  const header = renderHeader();

  // const renderDueHeader = () => {
  //   return (
  //     <Grid container sx={{ my: 1, flexDirection: "row" }}>
  //       <Grid sx={{ margin: 1, flexGrow: 1 }}>
  //         <ArrowBackIosNewIcon
  //           style={{ marginRight: "10px", cursor: "pointer" }}
  //           onClick={sortRecords}
  //         />

  //       </Grid>
  //       <Grid md={3} sx={{ margin: 1 }}>
  //         <span className="p-input-icon-left">
  //           <i className="pi pi-search" />
  //           <InputText
  //             value={globalFilterValue}
  //             onChange={onGlobalFilterChange}
  //             placeholder="Search by Filing Name"
  //             size={25}
  //           />
  //         </span>
  //       </Grid>
  //       <Grid
  //         md={3}
  //         sx={{ margin: 1, pl: 2, display: "flex", justifyContent: "end" }}
  //       >
  //         <Button
  //           sx={{ p: 1, mx: 2, backgroundColor: "#0b3edf" }}
  //           color="primary"
  //           variant="contained"
  //           onClick={sortRecords}
  //         >
  //           CLEAR
  //         </Button>
  //       </Grid>
  //     </Grid>
  //   );
  // };

  // const headerDue = renderDueHeader();
  const handleTabChange = (event, newValue) => {
    // console.log("YearCheck -TabChange", "newVal", newValue, "currentYear", currentYearVal, "selectedYear", selectedYear);
    setMasterCatFilter([]);
    setUpcomingCatFilter([]);
    setActiveFilters([]);
    setSelectedMasters(null)
    setMasters([]);
    setFilingMasters([]);
    setIsLoading(true);
    setGlobalFilterValue("");
    setIsClearIcon(false)
    setFilters(createInitialFilters());
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    if (search.current) {
      search.current.value = "";
    }
    // console.log("tracktab",newValue);
    setValue(newValue);
    if (newValue === '2') {
      setIsDisabled(true);
    } else {
      setSelectedYear(currentYearVal - 1)
      setIsDisabled(false);
    }
  };
  const handleYearChange = (event) => {
    // console.log("YearCheck -yearChange", "event", event, "currentYear", currentYearVal, "selectedYear", selectedYear);
    setMasters([])
    setFilingMasters([])
    setSelectedMasters(null)
    setGlobalFilterValue("")
    setIsClearIcon(false)
    setMasterCatFilter([])
    setUpcomingCatFilter([]);
    setActiveFilters([]);
    setFilters(createInitialFilters());
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    if (search.current) {
      search.current.value = "";
    }
    setIsLoading(true);
    setSelectedYear(event.target.value);
  };

  const editMasterFilling = () => {
    if (selectedmasters) {
      delete selectedmasters.stateList;
      const filingPeriodYear = selectedYear
      setCurrentFilingMaster(selectedmasters);
      if (value == 2) {
        navigate("/postaward-master-form", {
          state: {
            page: "FilingMasterHistory",
            filingPeriodYear
          },
        });
      } else {
        navigate("/postaward-master-form")
      }
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };

  const deleteMasterRecord = async () => {
    setIsLoading(true);
    try {
      if (selectedmasters) {
        try {
          let payLoad = { ...selectedmasters };
          //payLoad.changesInprogress = undefined;
          payLoad.createUser = authUser.userId + "";
          payLoad.createDate = new Date();
          payLoad.recordType = "PostAward";

          // payLoad.programInfo = [];
          delete payLoad.stateList;

          // console.log("pay#", payLoad);
          const res = await deleteDraftFilingMaster(payLoad);
          // console.log("Draft Res:", res);
          if (res) {
            const wfPayload = {
              draftId: res.draftId,

              // currentApproverId: 1,
              WorkflowInitiatorId: authUser?.userId + "",
              createUser: authUser?.userId + "",
              createDate: new Date(),
            };
            let res3 = null;
            if (createPostAwardWorkflow) {
              res3 = await createPostAwardWorkflow(wfPayload);
            }
            if (res3) {
              // console.log("deleteMasterRecord", res3);
              setCurrentFilingMaster(null);
              // showAlert(
              //   "Success",
              //   `Successfully submitted delete request for ${selectedmasters.filingName}`,
              //   "success"
              // );

              // closeDialog();
              setShowdeleteAlert(true);
            }
          } else {
            setAlertMessage(
              <Typography>
                Unexpected Error occured while deleting the
                <Typography fontWeight="bold" component="span">
                  {selectedmasters.filingName},
                </Typography>{" "}
              </Typography>
            );
            closeDialog();
          }
        } catch (error) {
          console.log("@@Error:", error);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const FilingCommentButton = ({ rowData }) => {
    const isPermissionEnabled = usePermission("PostAwardMasterList", "comments", rowData?.customer[0]?.customerId);
    const isActive = Boolean(rowData.hasComments) && isPermissionEnabled;
    return (
      <IconButton
        disabled={!isActive}
        onClick={() => addComment(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          mr: 1,
          pointerEvents: !isActive ? 'none' : 'auto',
          cursor: !isActive ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : '#f5f5f5',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 20%, white)' : '#f5f5f5'
          }
        }}
      >
        <GoogleMaterialIcon
          name="comment"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };
  const FilingAttachmentButton = ({ rowData }) => {
    const isPermissionEnabled = usePermission("PostAwardMasterList", "referenceDocument", rowData?.customer[0]?.customerId);
    const isActive = Boolean(rowData.hasAttachments) && isPermissionEnabled;
    return (
      <IconButton
        disabled={!isActive}
        onClick={() => displayAttachments(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          pointerEvents: !isActive ? 'none' : 'auto',
          cursor: !isActive ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : '#f5f5f5',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 20%, white)' : '#f5f5f5'
          }
        }}
      >
        <GoogleMaterialIcon
          name="snippet_folder"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yy");
      //  console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const toLocalTime2 = (date) => {
    // console.log("toLocalTime", date);
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-LL-yyyy hh:mm:ss"),
        "dd-LL-yyyy hh:mm:ss",
        { zone: "UTC" }
      ).toFormat("yyyy-LL-dd");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const rowExpansionTemplate = (data) => {
    // console.log("rowExpansionTemplate", data.filingPeriods);
    if (data.filingPeriods.length > 0) {
      let tableData = data.filingPeriods.map((ele) => {
        let startDate = new Date(ele.startDate);
        let endDate = new Date(ele.endDate);
        const toLocalDateString = date => date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

        let fp = `${toLocalDateString(startDate)} - ${toLocalDateString(endDate)}`;
        let dueDate = ele.dueDate !== null ? toLocalDateString(new Date(ele.dueDate)) : null;
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: dueDate,
        };
      });
      return (
        <div className="filingPeriodTable p-3" style={{ width: "20vw" }}>
          {/* <h5>Filing Period for {data.filingName}</h5> */}
          <DataTable value={tableData}>
            <Column field="filingPeriod" header="Filing Period"></Column>
            {/* <Column field="dueDate" header="DueDate"></Column> */}
          </DataTable>
        </div>
      );
    } else {
      return (
        <div className="filingPeriodTable p-3">
          <h5>No Filing Period for {data.filingName}</h5>
        </div>
      );
    }
  };

  const rowExpand = (event) => {
    // console.log("rowExpand", event, expandedRows);
    setExpandedRows(event.data);
  };

  const closeAlert = () => {
    setShowAlert(false);
    setRefreshRecordList(true);
  };

  const tableRef = useRef(null);
  const historyTableRef = useRef(null);
  const pageSize = 100;

  // lazy load function
  const loadDataLazy = async (event) => {
    console.log("loadDataLazy props", recordsInView, event);

    //Virtual scroll callback
    const vScroll = value === "1"
      ? tableRef.current.getVirtualScroller()
      : historyTableRef.current.getVirtualScroller()
    if (!vScroll?.getRenderedRange) {
      return;
    }
    let range = vScroll.getRenderedRange();
    let { first, last } = range.viewport;
    // console.log("loadDataLazy vScroll", vScroll, range.viewport);

    let firstVal = recordsInView * pageSize;
    // console.log(
    //   "loadDataLazy totalRecords",
    //   firstVal,
    //   totalRecords,
    //   lazyLoading,
    //   masters.length,
    // );


    if (
      firstVal < totalRecords &&
      first > masters.length - pageSize / 5 &&
      !lazyLoading
    ) {
      //scroll down
      // setIsLoading(true);
      setLazyLoading(true);
      let lastVal = firstVal + pageSize;
      // console.log("loadDataLazy d firstVal", firstVal, lastVal);

      //get next data
      let records = await loadRecordsList(firstVal, lastVal, "down");
      // console.log("loadDataLazy d record", records);
      if (records) {
        // console.log("loadDataLazy d scrollInView", recordsInView * 100);

        //scroll to next records
        vScroll.scrollInView(recordsInView * 100);
        setRecordsInView((old) => old + 1);
        setLazyLoading(false);
        setIsLoading(false);
      }
    } else if (last < pageSize / 5 && recordsInView > 1 && !lazyLoading) {
      // scroll up
      let firstVal = (recordsInView - 3) * pageSize;
      let lastVal = firstVal + pageSize;
      if (firstVal >= 0) {
        // setIsLoading(true);
        setLazyLoading(true);
        // console.log("loadDataLazy u firstVal", firstVal, lastVal);

        //get prev data
        let records = await loadRecordsList(firstVal, lastVal, "up");
        // console.log("loadDataLazy u record", records);
        if (records) {
          // console.log("loadDataLazy u scrollInView", (recordsInView - 3) * 100);

          //scroll to prev records - scroll to middle to prevent immediate re-trigger
          vScroll.scrollToIndex(pageSize * 1.5);
          setRecordsInView((old) => old - 1);
          setLazyLoading(false);
          setIsLoading(false);
        }
      }
    }
  };

  // api call for lazy load
  const loadRecordsList = async (first, last, direction) => {
    console.log("loadRecordsList props", first, last, direction);
    setIsLoading(true);
    const buildBaseUrl = (startRow, endRow) => {
      let baseUrl = `${API_BASE_URL}/FilingMaster/PostAwardFilingMasterListByPagination?StartRow=${startRow + 1}&EndRow=${endRow}&recordType=PostAward`;
      if (value === "2" && selectedYear !== "") {
        baseUrl = `${baseUrl}&Year=${selectedYear}`;
      }
      return baseUrl;
    };

    const appendFiltersToUrl = (baseUrl, filters) => {
      let updatedUrl = baseUrl;
      filters.forEach((ele) => {
        const filterName = encodeURIComponent(ele.name);
        const filterValue = encodeURIComponent(ele.val);
        const searchType = ele.searchType ? encodeURIComponent(ele.searchType) : "";
        const searchTypeVal = ele.searchTypeVal ? encodeURIComponent(ele.searchTypeVal) : "";
        updatedUrl = `${updatedUrl}&${filterName}=${filterValue}${ele.searchType ? `&${searchType}=${searchTypeVal}` : ``}`;
      });
      return updatedUrl;
    };

    const appendSortToUrl = (baseUrl) => {
      let updatedUrl = baseUrl;
      if (
        sortingData &&
        typeof sortingData === "object" &&
        sortingData.sortBy !== "" &&
        sortingData.sortOrder !== ""
      ) {
        let sortParameter = getSortData(sortingData.sortBy);
        let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";
        updatedUrl = `${updatedUrl}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
      }
      return updatedUrl;
    };

    const allFilters = (isFilterChange !== undefined && isFilterChange.length > 0 ? isFilterChange : []).map((filter) => {
      if (filter.name === "SearchByFilingFrequency") {
        return {
          ...filter,
          searchType: "FilingFrequencySearchType",
          searchTypeVal: "EqualTo",
        };
      }
      return filter;
    });
    const frequencyFilters = allFilters.filter((filter) => filter.name === "SearchByFilingFrequency");
    const hasFrequencySelection = frequencyFilters.length > 0;
    const normalizeFrequencyToken = (value) =>
      (value ?? "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[\s\-_]+/g, "");
    const selectedFrequencyTokens = new Set(
      frequencyFilters
        .map((filter) => normalizeFrequencyToken(filter.val))
        .filter(Boolean)
    );
    const isSelectedFrequency = (item) => {
      if (selectedFrequencyTokens.size === 0) {
        return true;
      }
      const recordFrequency = item?.filingFrequency;
      if (!recordFrequency) {
        return false;
      }
      const itemTokens = recordFrequency
        .toString()
        .split(/[,/|]/)
        .map((token) => normalizeFrequencyToken(token))
        .filter(Boolean);
      if (itemTokens.length === 0) {
        return false;
      }
      return itemTokens.some((token) => selectedFrequencyTokens.has(token));
    };

    // console.log("loadRecordsList url", url);
    try {
      if (hasFrequencySelection) {
        const nonFrequencyFilters = allFilters.filter(
          (filter) => filter.name !== "SearchByFilingFrequency"
        );
        const frequencySearchType = "EqualTo";

        let bulkFetchUrl = buildBaseUrl(0, 10000);
        bulkFetchUrl = appendFiltersToUrl(bulkFetchUrl, nonFrequencyFilters);
        bulkFetchUrl = appendSortToUrl(bulkFetchUrl);

        const uniqueFrequencies = Array.from(
          new Set(
            frequencyFilters
              .map((filter) => filter.val)
              .filter((value) => value !== null && value !== undefined && value !== "")
          )
        );

        const responses = await Promise.all(
          uniqueFrequencies.map((frequency) => {
            const frequencyFilter = [
              {
                name: "SearchByFilingFrequency",
                val: frequency,
                searchType: "FilingFrequencySearchType",
                searchTypeVal: frequencySearchType,
              },
            ];
            const requestUrl = appendFiltersToUrl(bulkFetchUrl, frequencyFilter);
            return axios.get(requestUrl);
          })
        );

        const mergedMap = new Map();
        responses.forEach((response) => {
          const items = (response?.data?.items || []).filter((item) =>
            isSelectedFrequency(item)
          );
          items.forEach((item) => {
            const key = item.filingId ?? item.draftId ?? `${item.filingName}-${item.stateInfo}-${item.juristiction}`;
            if (!mergedMap.has(key)) {
              mergedMap.set(key, item);
            }
          });
        });

        const mergedItems = Array.from(mergedMap.values());
        const pagedItems = mergedItems.slice(first, last);

        let ogList = masters.map((ele) => ele);
        setMasters([]);
        await modifyList(pagedItems, direction, ogList);
        setTotalRecords(mergedItems.length);
        return pagedItems;
      }

      let url = buildBaseUrl(first, last);
      url = appendFiltersToUrl(url, allFilters);
      url = appendSortToUrl(url);

      const res = await axios.get(url);
      if (!res.data) {
        return false;
      }

      if (res.data) {
        let ogList = masters.map((ele) => ele)
        await modifyList(res.data.items, direction, ogList);
        setTotalRecords(res.data.totalItems);
        // setMasters(res.data.items)
        return res.data.items;
      } else {
        return false;
      }
    } catch (err) {
      console.log("loadRecordsList err", err);
    }
  };

  //maping records for lazy load
  const modifyList = (list, direction, ogList) => {
    console.log("modifyList", list, direction, ogList);
    if (list.length > 0) {
      //list has data

      // setOgList(og)    

      // console.log("loadDataLazy og", ogList, masters);
      // console.log("modifyList og", ogList, masters);

      let allCats = [];
      let fedLookup = [];
      let stateCatLookup = [];
      let federalPostAwardLookup = [];
      let statePostAwardLookup = [];

      //formating list
      const updFilingMasters = list
        .map((item, i) => {
          // console.log(`filingMasters ...`, item);

          const _stateList = getStateName(item.stateInfo);
          // console.log("ProgramInfo", item.programInfo);
          const programName = item.programInfo && item.programInfo.length > 0
            ? item.programInfo[0].programName
            : '';


          // console.log("ProgramName", programName);

          const toLocalDateString = (date) => {
            // console.log("dateCheck", date);
            return date.toLocaleDateString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
            });
          };
          const _filingPeriods = item.filingPeriods.map(period => (
            `${toLocalDateString(new Date(period.startDate))}-${toLocalDateString(new Date(period.endDate))}`
          )).join(', ');
          // console.log("filingpCheck", _filingPeriods);
          // const categories = _categories.join(", ");
          // console.log(`filingMasters ${item.filingMasters} cat...`, categories);
          if (item.juristiction?.includes("Federal")) {
            // setFederalCategoriesLookup((old) => [...old, categories])

            // const _categories = _.map(
            //   item.businessCategory,
            //   "businessCategoryName"
            // ).join(", ");
            if (
              !federalPostAwardLookup.includes(programName) &&
              programName !== ""
            ) {
              // setPostAwardFederalArray([...postawardfederalArray,programName]);
              federalPostAwardLookup.push(programName);
            }
            allCats.push(programName);
            fedLookup.push(programName);
            setPostAwardFederalArray(federalPostAwardLookup);

            return {
              ...item,
              federalCategories: programName,
              stateList: _stateList,
              formattedFilingperiods: _filingPeriods,
              masterId: `${i}${item.filingId}`,
            };
            // console.log("item.programName", programName);
          } else if (item.juristiction?.includes("Both")) {
            // setFederalCategoriesLookup((old) => [...old, categories])

            // const _categories = _.map(
            //   item.businessCategory,
            //   "businessCategoryName"
            // ).join(", ");
            if (
              !federalPostAwardLookup.includes(programName) &&
              programName !== ""
            ) {
              // setPostAwardFederalArray([...postawardfederalArray,programName]);
              federalPostAwardLookup.push(programName);
            }

            if (
              !statePostAwardLookup.includes(programName) &&
              programName !== ""
            ) {
              statePostAwardLookup.push(programName);
            }

            allCats.push(programName);
            fedLookup.push(programName);
            setPostAwardFederalArray(federalPostAwardLookup);
            stateCatLookup.push(programName);
            setStateCategoriesLookup((old) => [...old, programName]);
            setPostAwardStateArray(statePostAwardLookup);

            return {
              ...item,
              federalCategories: programName,
              stateCategories: programName,
              stateList: _stateList,
              formattedFilingperiods: _filingPeriods,
              masterId: `${i}${item.filingId}`,
            };
            // console.log("item.programName", programName);
          } else {
            // console.log(
            //   "stateCategories: props",
            //   item.stateInfo,
            //   item.businessCategory
            // );

            const categoriesState = item.businessCategory.filter(
              (ele) => ele.state === item.stateInfo
            );
            // console.log(
            //   "stateCategories: filter",
            //   item.filingName,
            //   categoriesState
            // );
            if (
              !statePostAwardLookup.includes(programName) &&
              programName !== ""
            ) {
              // setPostAwardFederalArray([...postawardfederalArray,programName]);
              statePostAwardLookup.push(programName);
            }
            // const _categories = categoriesState
            //   .map((ele) => ele.businessCategoryName)
            //   .join(", ");
            // console.log("stateCategories: join", _categories);

            allCats.push(programName);
            stateCatLookup.push(programName);
            setStateCategoriesLookup((old) => [...old, programName]);
            setPostAwardStateArray(statePostAwardLookup);
            return {
              ...item,
              stateCategories: programName,
              stateList: _stateList,
              formattedFilingperiods: _filingPeriods,
              masterId: `${i}${item.filingId}`,
            };
          }
        });
      // console.log("modifyList updFilingMasters", updFilingMasters);


      let updFilingMastersList
      if (direction === "down") {
        //scroll down
        if (masters.length >= pageSize * 2) {
          //list >= 2 pages

          //remove first pageSize records and add new data
          let unloadList = ogList.slice(pageSize);
          // console.log("modifyList dw unloadList", unloadList);

          //add new data
          updFilingMastersList = [...unloadList, ...updFilingMasters];
          // console.log("modifyList dw updFilingMastersList", updFilingMastersList);

          let list = updFilingMastersList.map((ele) => ele)
          setMasters(list);
          setFilingMasters(list)
          // console.log("modifyList list", list);
        } else {
          //list < 2 pages

          // add new data to list
          updFilingMastersList = [...ogList, ...updFilingMasters];
          console.log("modifyList dw updFilingMastersList", updFilingMastersList);
          let list = updFilingMastersList.map((ele) => ele)
          setMasters(list);
          setFilingMasters(list)
          console.log("modifyList list", list);
        }
      } else if (direction === "up") {
        //scroll up
        if (masters.length >= pageSize * 2) {
          //list >= 2 pages

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updFilingMasters, ...unloadList];
          // console.log("modifyList up updFilingMastersList", updFilingMastersList);

          let list = updFilingMastersList.map((ele) => ele)
          setMasters(list);
          setFilingMasters(list)
          // console.log("modifyList list", list);

        } else {
          //list < 2 pages

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updFilingMasters, ...unloadList];
          // console.log("modifyList up updFilingMastersList", updFilingMastersList);
          let list = updFilingMastersList.map((ele) => ele)
          setMasters(list);
          setFilingMasters(list)
          // console.log("modifyList list", list);

        }
      }

      setFederalCategoriesLookup(Array.from(new Set(fedLookup)));
      setStateCategoriesLookup(Array.from(new Set(stateCatLookup)));
      setCategoriesLookup(Array.from(new Set(allCats)));
      setRefreshRecordList(false)
      setIsLoading(false);
      return updFilingMastersList
    } else {
      //list empty
      // console.log("modifyList empty",list)
      setIsLoading(false);
      setMasters([]);
      setFilingMasters([])
      return []

    }
  };

  //table filter change
  const onFilterChange = async (e) => {
    // console.log("onFilterChange props", e.filters);
    let filterChange = [];
    const getConstraintValue = (col) => e?.filters?.[col]?.constraints?.[0]?.value;
    const getConstraintMatchMode = (col) => e?.filters?.[col]?.constraints?.[0]?.matchMode;
    const getValueList = (value) =>
      (Array.isArray(value) ? value : [value]).filter(
        (item) => item !== null && item !== undefined && item !== ""
      );
    const pushMultiValueFilters = ({ name, searchType, values, matchMode }) => {
      const normalizedValues = getValueList(values);
      normalizedValues.forEach((rawValue, index) => {
        const changeItem = {
          name,
          val: rawValue,
        };
        if (index + 1 === normalizedValues.length && searchType) {
          changeItem.searchType = searchType;
          changeItem.searchTypeVal = getSearchType(matchMode);
        }
        filterChange.push(changeItem);
      });
    };

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        // console.log("onFilterChange col", col, e.filters[col]);
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value.map((ele, i) => {
                let changeItem = {
                  name: `SearchByState`,
                  val: getStateCode(ele),
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `StateSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              })
              : filterChange.push({
                name: `SearchByState`,
                val: getStateCode(e.filters[col].constraints[0].value),
                searchType: `StateSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
          } else if (col === "juristiction") {
            filterChange.push({
              name: `SearchByJurisdiction`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (col === "required") {
            filterChange.push({
              name: `SearchByRequired`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (
            col === "filingFrequency" &&
            Array.isArray(e.filters[col].constraints[0].value)
          ) {
            e.filters[col].constraints[0].value.forEach((ele, i) => {
              let changeItem = {
                name: `SearchByFilingFrequency`,
                val: ele,
              };
              if (i + 1 === e.filters[col].constraints[0].value.length) {
                changeItem.searchType = `FilingFrequencySearchType`;
                // Filing Frequency comes from a fixed list; use exact match
                // to avoid "Annually" matching "Semi-Annually".
                changeItem.searchTypeVal = "EqualTo";
              }
              filterChange.push(changeItem);
            });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: e.filters[col].constraints[0].value,
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "dueDate") {
            filterChange.push({
              name: `SearchByDueDate`,
              val: formatFilterDate(e.filters[col].constraints[0].value),
              searchType: `DueDateSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "federalCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileFederal`,
              searchType: `WhoMustFileFederalSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else if (col === "stateCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileInState`,
              searchType: `WhoMustFileInStateSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: e.filters[col].constraints[0].value,
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          }
        }
      });
    }

    //set filter
    console.log("onFilterChange filterChange", filterChange);
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  const getSortData = (val) => {
    // console.log("getSortData props", val);
    if (val === "dueDate") {
      return {
        SortByParameter: "SortByDuedate",
        SortByVal: "DueDate",
        SortOrderParameter: "SortOrderDuedate"
      }
    } else if (val === "stateList") {
      return {
        SortByParameter: "SortByStateInfo",
        SortByVal: "StateInfo",
        SortOrderParameter: "SortOrderStateInfo"
      }
    } else if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortByBusinessCategory",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrderBusinessCategory"
      }
    } else {
      return {
        SortByParameter: `SortBy${val.charAt(0).toUpperCase() + val.slice(1)}`,
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: `SortOrder${val.charAt(0).toUpperCase() + val.slice(1)}`
      }
    }
  }

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    // console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
    setRecordsInView(0);
    setIsLoading(true);
    setMasters([]);
    setFilingMasters([])
  };

  //table sort change
  const handleSort = async (e) => {
    // console.log("handleSort props",e ,e.sortField)
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInView(0);
      setMasters([]);
      setIsLoading(true)
    }
  }


  useEffect(() => {
    console.log("filter/sort change", isFilterChange, sortingData, !lazyLoading, !refreshRecordList);
    //on filter/sort change
    if (!lazyLoading && !refreshRecordList) {
      const sortAndFilterApiCall = async () => {
        console.log("LOAD Check 4");
        let records = await loadRecordsList(0, pageSize, "down");
        console.log("recordsCheck", records);
        setIsLoading(false);
        setRecordsInView(1)
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  const refreshRecords = async () => {
    // console.log("refreshRecords")

    //Virtual scroll callback
    const vScroll = value === "1"
      ? tableRef.current.getVirtualScroller()
      : historyTableRef.current.getVirtualScroller()
    let range = vScroll.getRenderedRange();
    console.log("refreshRecords vScroll range", vScroll, range);

    let records
    console.log("refreshRecords refreshDetails", refreshDetails);
    if (refreshDetails?.pageInView || refreshDetails?.noOfPages) {
      let first = refreshDetails.pageInView * pageSize
      records = await loadRecordsList(first, first + refreshDetails?.noOfPages * pageSize, "down");
    } else {
      records = await loadRecordsList(0, pageSize, "down");
    }

    if (records) {
      if (refreshDetails?.viewport && refreshDetails?.noOfPages) {
        setRecordsInView((old) => old + refreshDetails?.noOfPages);
        // setRefreshDetails(null)
      } else {
        setRecordsInView((old) => old + 1);
      }
      setLazyLoading(false)
    }
  }


  useEffect(() => {
    // console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords()
    }

  }, [refreshRecordList])

  const handleRrefreshList = () => {
    //Virtual scroll callback
    const vScroll = value === "1"
      ? tableRef.current.getVirtualScroller()
      : historyTableRef.current.getVirtualScroller()
    let range = vScroll.getRenderedRange();
    console.log("refreshTable vScroll", vScroll, range);

    let pageInView
    let noOfPages
    if (masters.length > 100) {
      pageInView = recordsInView - 2
      noOfPages = 2
    } else {
      pageInView = recordsInView - 1
      noOfPages = 1
    }
    let clientSelected = masters
    console.log("refreshTable clientSelected", masters, clientSelected);

    setRecordsInView(pageInView)
    setRefreshDetails({
      viewport: range.viewport,
      pageInView,
      noOfPages,
      clientSelected
    })

    setIsLoading(true);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setMasters([])
    setRefreshRecordList(true)
  }

  useEffect(() => {
    // console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    // console.log("recordsInView,", recordsInView);
  }, [recordsInView]);

  useEffect(() => {
    // console.log("lazyLoading", lazyLoading) 
  }, [lazyLoading])

  useEffect(() => {
    //  console.log("isLoading", isLoading) 
  }, [isLoading])

  useEffect(() => {
    // console.log("masters,", masters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masters, masters.length, JSON.stringify(masters)]);

  useEffect(() => {
    console.log("filingMasters,", filingMasters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filingMasters, filingMasters.length]);

  return (


    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        px: { xs: 1, sm: 2, md: 3, lg: 4 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          width: "100%",
          maxWidth: "1800px",
        }}
      >

        {/* LEFT SIDE (Tabs + Table) */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <div
            className='card'
            style={{
              maxWidth: "90vw",
              padding: "1rem",
              //margin: "1rem",
              background: tokens.colors.offWhite,
              borderRadius: "8px",
              position: "relative",
            }}
          >
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange}>
                  <Tab label='Postaward Master Active' value='1' disabled={isLoading} />
                  <Tab label='Postaward Master History' value='2' disabled={isLoading} />
                </TabList>
              </Box>
              <TabPanel value='1'>
                <DataTable
                  key="list"
                  scrollable
                  resizableColumns
                  columnResizeMode="expand"
                  showGridlines
                  className="frozen-mf-pa"
                  value={filingMasters}
                  selection={selectedmasters}
                  onSelectionChange={(e) => setSelectedMasters(e.value)}
                  dataKey='masterId'
                  onRowSelect={onRowSelect}
                  loading={isLoading}
                  onRowToggle={(e) => rowExpand(e)}
                  rowExpansionTemplate={rowExpansionTemplate}
                  expandedRows={expandedRows}
                  globalFilterFields={["filingName"]}
                  header={header}
                  ref={tableRef}
                  virtualScrollerOptions={{
                    onScroll: loadDataLazy,
                    itemSize: 45,
                    delay: 0,
                    scrollHeight: "550px",
                    appendOnly: true,

                  }}
                  style={{ width: "100%", minWidth: "100%", borderRadius: "8px", overflow: "hidden", border: "none", background: tokens.colors.offWhite }}
                  scrollHeight="550px"
                  sortField={sortingData.sortBy}
                  sortOrder={sortingData.sortOrder}
                  onSort={(e) => handleSort(e)}
                >
                  <Column expander={true} className='expandableColumn-fm' style={{ width: "5rem" }} />
                  <Column
                    selectionMode="single"
                    headerStyle={{ width: "3rem" }}
                    style={{ width: "3rem", textAlign: "center" }}
                  >
                    Select
                  </Column>
                  {/* <Column
                headerStyle={{ width: "2rem" }}
                // header="Attachemts"
                body={(rowData) => <FilingCommentButton rowData={rowData} />}
              ></Column>
              <Column
                headerStyle={{ width: "2rem" }}
                // header="Attachemts"
                body={(rowData) => (
                  <FilingAttachmentButton rowData={rowData} />
                )}
              ></Column> */}
                  <Column
                    header="Indicators"
                    style={{ textAlign: "center" }}
                    body={(rowData) => (
                      <>
                        <Stack direction="row">
                          <FilingCommentButton rowData={rowData} />

                          <FilingAttachmentButton rowData={rowData} />
                        </Stack>
                      </>
                    )}
                  ></Column>
                  <Column
                    field="filingName"
                    header="Filing Name"
                    sortable
                    frozen={enableForzen}
                    className="filingNameColumn-pa"
                    style={{ minWidth: "11rem", maxWidth: "25rem" }}
                    body={(rowData) => cellListDisplayName(rowData)}
                  ></Column>
                  <Column
                    field="filingFrequency"
                    header="Filing Frequency"
                    frozen={enableForzen}

                    style={{ minWidth: "15rem" }}
                  ></Column>
                  <Column
                    field="stateList"
                    header="State"
                    sortable
                    frozen={enableForzen}

                    style={{ minWidth: "13rem" }}
                    className="column-small"
                  ></Column>
                  <Column
                    field="ruleInfo"
                    header="Rule Info"
                    style={{ minWidth: "15rem", maxWidth: "15rem" }}
                    body={(rowData) => cellListDisplayRuleInfo(rowData)}
                  ></Column>
                  <Column
                    field="required"
                    header="Required?"
                    style={{ minWidth: "13rem" }}
                    className="column-small"
                  ></Column>
                  <Column
                    field="federalCategories"
                    header="Who Must File Federal"
                    style={{ minWidth: "18rem", maxWidth: "18rem" }}
                  ></Column>
                  <Column
                    field="stateCategories"
                    header="Who Must File in State"
                    style={{ minWidth: "18rem", maxWidth: "18rem" }}
                  ></Column>
                  <Column
                    field="jsicontactName"
                    header="JSI Staff"
                    style={{ minWidth: "12rem" }}
                  ></Column>
                  <Column
                    field="juristiction"
                    header="Jurisdiction"
                    sortable
                    style={{ minWidth: "10rem" }}
                  ></Column>
                  <Column
                    field="whereToFile"
                    header="Where to File"
                    body={(rowData) => cellListDisplayWhereToFile(rowData)}
                    style={{ minWidth: "13rem", maxWidth: "13rem" }}
                  ></Column>
                  <Column
                    field="notes"
                    header="Notes"
                    headerStyle={{ minWidth: "20rem", maxWidth: "20rem" }}
                    style={{ minWidth: "45rem", maxWidth: "45rem" }}
                    body={(rowData) => cellListDisplayNotes(rowData)}
                  ></Column>
                </DataTable>
              </TabPanel>
              <TabPanel value='2'>
                <DataTable
                  key="list"
                  scrollable
                  resizableColumns
                  columnResizeMode="expand"
                  showGridlines
                  className="frozen-mf-pa"
                  value={filingMasters}
                  selection={selectedmasters}
                  onSelectionChange={(e) => setSelectedMasters(e.value)}
                  dataKey='masterId'
                  onRowSelect={onRowSelect}
                  loading={isLoading}
                  onRowToggle={(e) => rowExpand(e)}
                  rowExpansionTemplate={rowExpansionTemplate}
                  expandedRows={expandedRows}
                  globalFilterFields={["filingName"]}
                  header={header}
                  ref={historyTableRef}
                  virtualScrollerOptions={{
                    onScroll: loadDataLazy,
                    itemSize: 45,
                    delay: 0,
                    scrollHeight: "550px",
                    appendOnly: true,

                  }}
                  style={{ width: "100%", minWidth: "100%", borderRadius: "8px", overflow: "hidden", border: "none", background: tokens.colors.offWhite }}

                  scrollHeight="550px"
                  sortField={sortingData.sortBy}
                  sortOrder={sortingData.sortOrder}
                  onSort={(e) => handleSort(e)}
                >
                  <Column expander={true} className='expandableColumn-fm' style={{ width: "5rem" }} />
                  <Column
                    selectionMode="single"
                    headerStyle={{ width: "3rem" }}
                    style={{ width: "3rem", textAlign: "center" }}
                  >
                    Select
                  </Column>
                  {/* <Column
                headerStyle={{ width: "2rem" }}
                // header="Attachemts"
                body={(rowData) => <FilingCommentButton rowData={rowData} />}
              ></Column>
              <Column
                headerStyle={{ width: "2rem" }}
                // header="Attachemts"
                body={(rowData) => (
                  <FilingAttachmentButton rowData={rowData} />
                )}
              ></Column> */}
                  <Column
                    header="Indicators"
                    style={{ textAlign: "center" }}
                    body={(rowData) => (
                      <>
                        <Stack direction="row">
                          <FilingCommentButton rowData={rowData} />

                          <FilingAttachmentButton rowData={rowData} />
                        </Stack>
                      </>
                    )}
                  ></Column>
                  <Column
                    field="filingName"
                    header="Filing Name"
                    sortable
                    frozen={enableForzen}

                    className="filingNameColumn-pa"
                    style={{ minWidth: "11rem", maxWidth: "25rem" }}
                    body={(rowData) => cellListDisplayName(rowData)}
                  ></Column>
                  <Column
                    field="filingFrequency"
                    header="Filing Frequency"
                    frozen={enableForzen}

                    style={{ minWidth: "15rem" }}
                  ></Column>
                  <Column
                    field="stateList"
                    header="State"
                    sortable
                    frozen={enableForzen}

                    style={{ minWidth: "13rem" }}
                    className="column-small"
                  ></Column>
                  <Column
                    field="ruleInfo"
                    header="Rule Info"
                    style={{ minWidth: "15rem", maxWidth: "15rem" }}
                    body={(rowData) => cellListDisplayRuleInfo(rowData)}
                  ></Column>
                  <Column
                    field="required"
                    header="Required?"
                    style={{ minWidth: "13rem" }}
                    className="column-small"
                  ></Column>
                  <Column
                    field="federalCategories"
                    header="Who Must File Federal"
                    style={{ minWidth: "18rem", maxWidth: "18rem" }}
                  ></Column>
                  <Column
                    field="stateCategories"
                    header="Who Must File in State"
                    style={{ minWidth: "18rem", maxWidth: "18rem" }}
                  ></Column>
                  <Column
                    field="jsicontactName"
                    header="JSI Staff"
                    style={{ minWidth: "12rem" }}
                  ></Column>
                  <Column
                    field="juristiction"
                    header="Jurisdiction"
                    sortable
                    style={{ minWidth: "10rem" }}
                  ></Column>
                  <Column
                    field="whereToFile"
                    header="Where to File"
                    body={(rowData) => cellListDisplayWhereToFile(rowData)}
                    style={{ minWidth: "13rem", maxWidth: "13rem" }}
                  ></Column>
                  <Column
                    field="notes"
                    header="Notes"
                    headerStyle={{ minWidth: "20rem", maxWidth: "20rem" }}
                    style={{ minWidth: "45rem", maxWidth: "45rem" }}
                    body={(rowData) => cellListDisplayNotes(rowData)}
                  ></Column>
                </DataTable>
              </TabPanel>
            </TabContext>

          </div>
        </Box>

        <Paper
          elevation={3}
          sx={{
            width: "48px",
            borderRadius: "50px",
            py: 2,
            px: 0.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
            position: "sticky",
            top: 100,
            backgroundColor: "#ffffff",
          }}
        >
          <PostAwardToolbox
            isLoading={isLoading}
            addComment={addComment}
            draft={selectedmasters?.customer[0]?.customerId}
            editMasterFilling={editMasterFilling}
            deleteMasterRecord={handleDelete}
            displayAttachments={displayAttachments}
            displayHistory={displayHistory}
            displayClients={displayClients}
            downloadData={exportExcel}
            downloadDataHistory={exportExcelHistory}
            isDisabled={sortRecord === "Clear"}
            isTabValue={value === "2"}
            downloadProgress={downloadProgress}
            downloadStatusMsg={downloadStatusMsg}
            isDownloading={showDownloadProgress}
          />
        </Paper>
      </Box>
      <ConfirmDialog />

      {
        <FilingMasterAttachment
          show={showAttachments}
          dockAt="right"
          tracker={selectedmasters}
          attachments={attachments}
          handleClose={closeAttachments}
        />
      }
      {
        <PostAwardFilingMasterHistory
          show={showHistory}
          dockAt="right"
          tracker={selectedmasters}
          commentActivityHistory={commentActivityHistory}
          activityHistory={activityHistory}
          handleClose={closeHistory}
        />
      }
      <CustomDialog
        header="Info"
        visible={showDeleteAlert}
        onHide={() => closeDeleteAlert()}
      >
        {`Successfully submitted delete request for `}
        <strong>{selectedmasters && selectedmasters.filingName}</strong>
      </CustomDialog>

      <ClientTableFilter
        anchorEl={filterAnchorEl}
        onClose={handleFilterClose}
        onApply={handleFilterApply}
        onClear={handleFilterClear}
        clients={masters}
        categoriesLookup={categoryList}
        programList={[]}
        stateList={stateArray}
        tracknowlicenseTypes={[]}
        postawardlicenseTypes={[]}
        roleType={""}
        postAwardFilingMasterMode={true}
        requiredOnlyIs={true}
        singleSelectForNonContainsColumns={["federalCategories", "stateCategories"]}
        singleSelectColumnsByMatchMode={{ stateList: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_CONTAINS] }}
        filterOptionsByColumn={{
          juristiction: [{ value: FilterMatchMode.EQUALS, label: "Is" }]
        }}
        availableValuesByColumn={{
          federalCategories: postawardfederalArray,
          stateCategories: postawardstateArray
        }}
      />

      <AlertDialog />

      <CustomDialog
        header="Selection Required"
        visible={showAlert1}
        onHide={() => closeAlert()}
        icon="⚠️"
      >
        {alertMessage}
      </CustomDialog>
      {
        <PostAwardFilingMasterComments
          show={showComments}
          dockAt="right"
          draft={selectedmasters}
          comments={comments}
          handleClose={closeComments}
          refreshTable={handleRrefreshList}
        />
      }
      {
        <PostAwardAssociatedClient
          show={showClient}
          dockAt="right"
          draft={selectedmasters}
          clients={clients}
          handleClose={closeClient}
        />
      }

      {/* <CircularProgress
          style={{
            //position: "absolute",
            //  width: "3rem",
            marginLeft: "36rem",
            marginTop: "10rem",
            color: "#0000FF",
          }}
          // type="spin"
          height="100%"
          position="center"
          place-items="center"
        /> */}
      <style>{`
  .p-datatable.frozen-mf-pa {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-mf-pa .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow: hidden !important;
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-mf-pa .p-datatable-header {
    background: ${tokens.colors.offWhite} !important;
    border: none !important;
    padding: 0 0 10px 0 !important;
    margin: 0 !important;
  }

  .frozen-mf-pa .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  /* HEADER */
  .frozen-mf-pa .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }

  .frozen-mf-pa .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .frozen-mf-pa .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  .frozen-mf-pa .p-datatable-thead > tr > th {
    background: transparent !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 12px 16px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
  }

  .frozen-mf-pa .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  /* Frozen columns z-index fix and primary background */
  .frozen-mf-pa .p-datatable-thead > tr > th.p-frozen-column {
    z-index: 2 !important;
    background: ${tableHeaderColor} !important;
    will-change: auto !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tokens.colors.white} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tokens.colors.offWhite} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-mf-pa .p-sortable-column-icon {
    color: #ffffff !important;
  }

  .frozen-mf-pa .p-selection-column,
  .frozen-mf-pa .p-datatable-tbody > tr > td.p-selection-column {
    text-align: center !important;
  }

  .frozen-mf-pa .p-selection-column .p-radiobutton {
    margin: 0 auto !important;
    display: inline-flex !important;
  }
  .frozen-mf-pa .p-selection-column .p-radiobutton .p-radiobutton-box {
    border: 2px solid ${tableHeaderColor} !important;
  }
  .frozen-mf-pa .p-selection-column .p-radiobutton .p-radiobutton-box.p-highlight,
  .p-radiobutton .p-radiobutton-box.p-highlight {
    border-color: ${tableHeaderColor} !important;
    background: ${tableHeaderColor} !important;
  }
  .frozen-mf-pa .p-selection-column .p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box:hover {
    border-color: ${tableHeaderColor} !important;
  }

  .frozen-mf-pa .p-datatable-tbody {
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-mf-pa .p-virtualscroller-content {
    background: ${tokens.colors.offWhite} !important;
  }

  /* ROWS - Alternating colors with gridlines */
  .frozen-mf-pa .p-datatable-tbody > tr {
    height: 45px !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr:nth-child(odd) > td {
    background-color: ${tokens.colors.white} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr:nth-child(even) > td {
    background-color: ${tokens.colors.offWhite} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  /* FORCE BORDERS ON ALL CELLS */
  .frozen-mf-pa .p-datatable-tbody > tr > td {
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
    border-left: none !important;
    border-top: none !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* Filing name and Row Expander column hover effect */
  .frozen-mf-pa .p-datatable-tbody > tr > td.filingNameColumn-fm:hover,
  .frozen-mf-pa .p-datatable-tbody > tr > td.expandableColumn-fm:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 8%, white) !important;
    cursor: pointer !important;
  }

  .frozen-mf-pa .p-datatable-tbody > tr > td.filingNameColumn-fm:hover {
    font-weight: 600 !important;
  }

  /* Row Expander Button ('>' icon) - Fast 0ms render, no round hover circle, no blue focus ring */
  .frozen-mf-pa .p-row-toggler {
    background: transparent !important;
    box-shadow: none !important;
    outline: none !important;
    border-radius: 0 !important;
    color: #212121 !important;
  }

  .frozen-mf-pa .p-row-toggler:hover,
  .frozen-mf-pa .p-row-toggler:focus,
  .frozen-mf-pa .p-row-toggler:active {
    background: transparent !important;
    box-shadow: none !important;
    outline: none !important;
  }

  /* Expanded / Active row toggler icon color becomes primary color */
  .frozen-mf-pa .p-row-toggler.p-row-toggler-highlight,
  .frozen-mf-pa .p-row-toggler[aria-expanded="true"] {
    color: ${tableHeaderColor} !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  /* SELECTED ROW */
  .frozen-mf-pa .p-datatable-tbody > tr.p-highlight > td,
  .frozen-mf-pa .p-datatable-tbody > tr.p-highlight > td.p-frozen-column {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
    will-change: auto !important;
  }

  /* SCROLLBAR */
  .p-datatable-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background: #C0BEC2;
    border-radius: 10px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: ${tableHeaderColor};
  }
`}</style>
    </Box >
  );
};

export default PostAwardFilingMasterList;
